

// $('.event--gallery--inner').each(function() {
//     $(this).mouseenter(function(){
//         var images = $(this).find('.right .swap--images');
//         console.log(images);
//         var indextest = 1;
        
//         for (let index = 1; index < images.length; index++) {
//             const element = images[index];
//             const indeximg = index + 1;
//             console.log(element);

//             // delay(element, indeximg);
//             setInterval(delay, 2000, element, indeximg);

//             // setInterval(function() {
//             //     $(element).addClass('relative');
//             //     $(element).css('z-index', indeximg);
//             // }, 1000); // .5 second delay
//             // var intervalId = setInterval(function(){
//             //     // delay(element, indeximg);
//             //     $(element).delay(1000).css('z-index', indeximg);
//             //  }, 1000);
//         }
        
//     })
// });

// function delay(element, indeximg) {
//     // setInterval(function() {
//         // $(element).addClass('relative');
//         $(element).delay(500).css('z-index', indeximg);
//         console.log(element);
//     // }, 1000); // .5 second delay
//   }

$('.link--tool--vorschlagen').on('click', function(){
    $('.block--toolbox').fadeIn(500);
})
$('.toolbox-filter, .hide--form').on('click', function(){
    $('.block--toolbox').fadeOut(1000);
})
$('.text-search input').on('input',function(){
    $('.block--toolbox').fadeOut(1000);
})
$('.text-search input').on('keypress',function(){
    $('.block--toolbox').fadeOut(1000);
})